import { getViemClients, } from "@bracket/contractor-next";
import type { Config } from "@wagmi/core";

import {
	getContractWithABI,
	isAddress,
	isBlockHash,
	type Address,
	type BlockHash,
	type ValidChainId,
} from "@bracket/chainography";




export declare type ClaimManagerPerformanceFeesProps = {
	/** Address for the subject vault */
	vault: string;
	chainId?: ValidChainId;
	config?: Config;
};


export const claimManagerPerformanceFees = async ({
	vault,
	chainId = 1,
	config,
}: ClaimManagerPerformanceFeesProps): Promise<BlockHash> => {

	try {

		if(chainId !== 1)
			throw new Error("claimManagerPerformanceFees supports only chain 1");

		if(!isAddress(vault))
			throw new Error("invalid vault address provided.");

		const [pub, priv] = await getViemClients({ chainId, config, });
		const [__, abi] = getContractWithABI("BracketVault");

		const {
			request,
		} = await pub.simulateContract({
			address: vault,
			abi,
			functionName: "claimManagerPerformanceFees",
			account: priv.account.address,
		})

		const hash = await priv.writeContract(request);
		await pub.waitForTransactionReceipt({ hash, timeout: 60_000, });
		if(isBlockHash(hash)) {
			return hash;
		}
		throw new Error("claimManagerPerformanceFees failed to produce a valid request");
	} catch (err) {
		throw new Error(`@bracket/chainography/BracketVault:claimManagerPerformanceFees failed - ${err.message}`);
	}
};
